import { useRef, useEffect, useCallback } from 'react';

const _ = require('lodash');

export function useDebouncedPerKeySave(autoSave, wait = 600) {
  const autoSaveRef = useRef(autoSave);
  useEffect(() => { autoSaveRef.current = autoSave; }, [autoSave]);

  const pendingChangesByKey = useRef({});
  const latestItemByKey = useRef({});
  const latestContextByKey = useRef({});
  const debouncedByKey = useRef({});

  useEffect(() => () => {
    Object.values(debouncedByKey.current).forEach(d => d.flush());
  }, []);

  return useCallback((csrfToken, team, item, changes, { flush = false } = {}) => {
    const key = item && (item.id || item.uuid || item._key);
    if (key == null) {
      autoSaveRef.current(csrfToken, team, { ...item, ...(changes || {}) });
      return;
    }
    latestItemByKey.current[key] = item;
    latestContextByKey.current[key] = { csrfToken, team };
    pendingChangesByKey.current[key] = {
      ...(pendingChangesByKey.current[key] || {}),
      ...(changes || {})
    };

    if (!debouncedByKey.current[key]) {
      debouncedByKey.current[key] = _.debounce(() => {
        const merged = {
          ...latestItemByKey.current[key],
          ...pendingChangesByKey.current[key]
        };
        const context = latestContextByKey.current[key];
        pendingChangesByKey.current[key] = {};
        autoSaveRef.current(context.csrfToken, context.team, merged);
      }, wait);
    }
    debouncedByKey.current[key]();
    if (flush) debouncedByKey.current[key].flush();
  }, [wait]);
}
